//@ts-check
import { Utils } from 'ecrion-components';
/**
 * @type {import("./types").camelCaseToDashType}
 */
// for optimization purpuses have the regex in constant variable

var camelCaseToWords = function camelCaseToWords(name) {
  function spaceWithUpper(match) {
    return ' ' + match.toUpperCase();
  }

  return Utils.formatting.capitalize(name).replace(/[A-Z]{1}/g, spaceWithUpper);
};

export default camelCaseToWords;